<template>
  <div class="container">
    <div class="d-flex justify-content-center align-items-center" id="main">
      <h1 class="mr-3 pr-3 align-top border-right inline-block align-content-center icon-color"><i class="far fa-check-square"></i></h1>
      <div class="inline-block align-middle">
        <h2 class="font-weight-normal lead" id="descPaid">Pagamento Recebido!</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss">

#main {
    height: 90vh;
}

#descPaid {
  font-size: 1.50rem;
  color: #4E9C81;
}

.icon-color {
  color: #4E9C81;
}

</style>
